module.exports = __webpack_public_path__ + "img/john.7b5fadc0.png";